import { ColumnApi, GridApi } from 'ag-grid-community';

export class DataGridApis {

  public gridApi: GridApi;

  public columnApi: ColumnApi;

}
